import { PasswordStrength } from './models/PasswordStrength';
export var errorTypeColour = 'errorMain';
export var weakTypeColour = 'alertMain';
export var goodTypeColour = 'successMain';
export var veryGoodTypeColour = 'successMain';
export var defaultTypeColour = 'uiLight';
export var bar = 'rounded mx-0.5 pl-4 border-t-4 pb-0 border-l-0 flex-1 ';
export var message = 'my-1 text-sm ';
export var getStrengthBarStyle = function (type, index) {
    var borderColour = bar + ' border-';
    switch (type) {
        case PasswordStrength.none:
            borderColour = borderColour + defaultTypeColour;
            break;
        case PasswordStrength.error:
            borderColour =
                borderColour + (index < 1 ? errorTypeColour : defaultTypeColour);
            break;
        case PasswordStrength.weak:
            borderColour =
                borderColour + (index < 2 ? weakTypeColour : defaultTypeColour);
            break;
        case PasswordStrength.good:
            borderColour =
                borderColour + (index < 3 ? goodTypeColour : defaultTypeColour);
            break;
        case PasswordStrength.veryGood:
            borderColour =
                borderColour + (index <= 4 ? veryGoodTypeColour : defaultTypeColour);
            break;
        default:
            borderColour = borderColour + defaultTypeColour;
            break;
    }
    return borderColour;
};
export var getStrengthBarMessageStyle = function (type) {
    switch (type) {
        case PasswordStrength.error:
            return 'text-' + errorTypeColour;
        case PasswordStrength.weak:
            return 'text-' + weakTypeColour;
        case PasswordStrength.good:
            return 'text-' + goodTypeColour;
        case PasswordStrength.veryGood:
            return 'text-' + veryGoodTypeColour;
        default:
            return 'text-' + defaultTypeColour;
    }
};
//# sourceMappingURL=password-strength-meter.style.js.map